import Colors from './Colors';
import { useStyleAndColor } from './StyleAndColorHooks';
import Styles from './Styles';

export default function StyleAndColor() {
  const { styles, palettes } = useStyleAndColor();

  // Show colors only if the selected style has multiple palettes to choose from
  const showColors = palettes.length > 1;

  return (
    <>
      {styles.length > 1 && <Styles />}
      {showColors && (
        <>
          <hr
            className="m-0 w-full border border-solid"
            style={{ borderColor: 'var(--nb-border, #e5e7eb)' }}
          />
          <Colors />
        </>
      )}
    </>
  );
}
